import { z } from 'zod';

// Flat Zod model for the Ontario Progress Report Card - Grades 7-8.
// Every key maps to one user-facing input. All fields are strings because
// PDF AcroForm values are strings and pill selections are string codes.
//
// Differences from pgrc1to6:
//   - socialStudiesPlan / socialStudiesResult removed
//   - historyPlan / historyResult added
//   - geographyPlan / geographyResult added
//   - boardInformation2 retained (present in gr7-8 PDF)

export const formSchema = z.object({
  // ── Student Info (Step 1) ─────────────────────────────────────────────────
  date:        z.string(),
  studentName: z.string(),
  oen:         z.string(),
  grade:       z.string(),
  teacher:     z.string(),

  // ── School Info (Step 2) ──────────────────────────────────────────────────
  board:     z.string(),
  school:    z.string(),
  address1:  z.string(),
  address2:  z.string(),
  principal: z.string(),
  telephone: z.string(),

  // ── Attendance (Step 3) ───────────────────────────────────────────────────
  daysAbsent:       z.string(),
  totalDaysAbsent:  z.string(),
  timesLate:        z.string(),
  totalTimesLate:   z.string(),
  boardInformation1: z.string(),

  // ── Learning Skills & Work Habits (Step 4) ───────────────────────────────
  responsibility:         z.string(),
  organization:           z.string(),
  independentWork:        z.string(),
  collaboration:          z.string(),
  initiative:             z.string(),
  selfRegulation:         z.string(),
  strengthsNextStepsLSWH: z.string(),

  // ── Subject Grades (Step 5) ───────────────────────────────────────────────
  languagePlan:             z.string(),
  languageResult:           z.string(),
  frenchPlan:               z.string(),
  frenchResult:             z.string(),
  nativeLanguage:           z.string(),
  nativeLanguagePlan:       z.string(),
  nativeLanguageResult:     z.string(),
  mathematicsPlan:          z.string(),
  mathematicsResult:        z.string(),
  scienceAndTechnologyPlan:    z.string(),
  scienceAndTechnologyResult:  z.string(),
  historyPlan:              z.string(),
  historyResult:            z.string(),
  geographyPlan:            z.string(),
  geographyResult:          z.string(),
  healthEducationPlan:      z.string(),
  healthEducationResult:    z.string(),
  physicalEducationPlan:    z.string(),
  physicalEducationResult:  z.string(),

  // ── Arts & Final Comments (Step 6) ────────────────────────────────────────
  artsHeader: z.string(),

  arts1:       z.string(),
  arts1Plan:   z.string(),
  arts1Result: z.string(),

  arts2:       z.string(),
  arts2Plan:   z.string(),
  arts2Result: z.string(),

  arts3:       z.string(),
  arts3Plan:   z.string(),
  arts3Result: z.string(),

  arts4:       z.string(),
  arts4Plan:   z.string(),
  arts4Result: z.string(),

  optionalStudies:       z.string(),
  optionalStudiesPlan:   z.string(),
  optionalStudiesResult: z.string(),

  strengthsNextStepsSubjects: z.string(),
  boardInformation2:          z.string(),
  _completedFields: z.array(z.string()).default([]),
});

export const defaultValues = {
  ...Object.fromEntries(
    Object.keys(formSchema.shape)
      .filter((k) => k !== '_completedFields')
      .map((k) => [k, ''])
  ),
  _completedFields: [],
};
